import { Link } from "react-router-dom";
import { HandCoins } from "lucide-react";

const VARIANTS = {
  gold: "bg-ngo-gold text-ngo-ink hover:shadow-[0_14px_36px_rgba(216,169,40,0.45)]",
  green: "bg-ngo-deep text-white hover:bg-ngo-forest shadow-[0_6px_20px_rgba(23,107,58,0.35)]",
  outline: "border-2 border-ngo-deep text-ngo-deep hover:bg-ngo-deep hover:text-white shadow-none",
};

const SIZES = {
  sm: "px-4 py-2 text-sm gap-1.5",
  md: "px-5 py-2.5 text-sm gap-2",
  lg: "px-7 py-3.5 text-base gap-2.5",
};

export default function DonateButton({ label, variant = "green", size = "md", className = "", testid = "donate-btn" }) {
  return (
    <Link
      to="/donate"
      data-testid={testid}
      className={`group inline-flex items-center justify-center rounded-full font-semibold transition-[background-color,transform,box-shadow,color] duration-300 hover:-translate-y-0.5 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      <HandCoins
        size={size === "lg" ? 18 : 16}
        className="transition-transform duration-300 group-hover:-rotate-12 group-hover:scale-110"
      />
      {label}
    </Link>
  );
}
